import { createSelector } from 'reselect';

const selectGateways = (state: any) => state.gateways;


export const selectGatewaysCurrentItem = createSelector([selectGateways], (gateways) => gateways.current);

export const selectGatewaysListItems = createSelector([selectGateways], (gateways) => gateways.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGatewaysListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGatewaysQueryItems = createSelector([selectGateways], (gateways) => gateways.query);

export const selectGatewaysQueryFQDNStatus = createSelector([selectGateways], (gateways) => gateways.fqdnCheck);
export const selectGatewaysReadKeys = createSelector([selectGateways], (gateways) => gateways.readKeys);

export const selectGatewaysCreatedItem = createSelector([selectGateways], (gateways) => gateways.create);

export const selectGatewaysUpdatedItem = createSelector([selectGateways], (gateways) => gateways.update);

export const selectGatewaysReadItem = createSelector([selectGateways], (gateways) => gateways.read);

export const selectGatewaysDeletedItem = createSelector([selectGateways], (gateways) => gateways.delete);

export const selectGatewaysSearchedItems = createSelector([selectGateways], (gateways) => gateways.search);

export const selectGatewaysItemsCount = createSelector([selectGateways], (gateways) => gateways.count);

export const selectGatewaysItemsFilter = createSelector([selectGateways], (gateways) => gateways.filter);